// extracted by mini-css-extract-plugin
export default {"root":"HeartLanding-root","title":"HeartLanding-title","text":"HeartLanding-text","image":"HeartLanding-image"};